import { useMemo } from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import ExtensionIcon from '@mui/icons-material/Extension';
import CloseIcon from '@mui/icons-material/Close';
import PlaceIcon from '@mui/icons-material/Place';
import { IproductHierarchy, IproductLocation } from '../../interface/IProducts';
import { MaterialReactTable, MRT_ColumnDef, useMaterialReactTable } from 'material-react-table';
import { DialogActions, Stack } from '@mui/material';


export interface ProductsItemHierarchyDialogProps {
  open: boolean;
  selectedValueLocation: IproductLocation[];
  selectedValueHierarchy: IproductHierarchy[];
  onClose: () => void;
  dialogTitle: string;
}

export default function ProductsItemHierarchyDialog(props: ProductsItemHierarchyDialogProps) {
  const { onClose, selectedValueLocation, selectedValueHierarchy, open } = props;

  const handleClose = () => {
    onClose();
  };

   const columnsHierarchy = useMemo<MRT_ColumnDef<IproductHierarchy>[]>(
    () => [
      // {
      //   accessorKey: 'id',
      //   header: 'id',
      //   enableEditing: false,
      //   enableGlobalFilter: false,

      // },
       {
        accessorKey: 'PARTNAME',
        header: 'PARTNAME',
        enableColumnFilter: false,
        size: 100,
        
       },
       {
        accessorKey: 'zoneName',
        header: 'zoneName',
        enableColumnFilter: false,
        size: 100,
        
       },
       {
        accessorKey: 'location',
        header: 'location',
        enableColumnFilter: false,
        size: 100,
        
       },
       {
        accessorFn: (row) => row?.stockDate?.substring(0,10), //alternate way
        //accessorKey: 'stockDate',
        header: 'stockDate',
        enableColumnFilter: false,
        size: 100,
        
       },
       {
        accessorFn: (row) => row?.quantity === 0 ? '' : row.quantity,
        //accessorKey: 'quantity',
        id: 'quantity',
        header: 'quantity',
        enableColumnFilter: false,
        size: 50,
        
       },



    ],
    [],
  );
  const columns = useMemo<MRT_ColumnDef<IproductLocation>[]>(
    () => [
      // {
      //   accessorKey: 'id',
      //   header: 'id',
      //   enableEditing: false,
      //   enableGlobalFilter: false,

      // },
       {
        accessorKey: 'zone.zoneName',
        header: 'Zone Name',
        enableColumnFilter: false,
        size: 100,
        


      },
      {
        accessorKey: 'location',
        header: 'location',
        enableEditing: false,
        enableColumnFilter: false,
        enableGlobalFilter: false,
        size: 100,

      },  


      {
        accessorFn: (row) => row?.stockDate?.substring(0,10), //alternate way
        //accessorKey: '',
        header: 'stock Date',
        enableColumnFilter: false,
        size: 100,




      },
      {
        accessorFn: (row) => row?.quantity === 0 ? '' : row.quantity,
        id: 'quantity',
        //accessorKey: 'quantity',
        header: 'quantity',
        enableColumnFilter: false,
        size: 60,


      },




    ],
    [],
  );
  const table = useMaterialReactTable({
    columns,
    data:   selectedValueLocation, //.filter(r=>{if (r.TYPE === 'R') return true; return false;}),
    initialState: { pagination: { pageSize: 15, pageIndex: 0 } ,     
      density: 'compact',                
    },
    enableGlobalFilter:false,
    enableColumnOrdering:false,
    enableColumnFilters:false,  
    enableFilterMatchHighlighting:false,   
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,   
  });
  const tableHirarchy = useMaterialReactTable({
    columns: columnsHierarchy,
    data:   selectedValueHierarchy, //.filter(r=>{if (r.TYPE === 'R') return true; return false;}),
    initialState: { pagination: { pageSize: 15, pageIndex: 0 } ,     
      density: 'compact',                
    },
    enableGlobalFilter:false,
    enableColumnOrdering:false,
    enableColumnFilters:false,  
    enableFilterMatchHighlighting:false,   
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,   
  });



  return (
    <Dialog onClose={handleClose} open={open} sx={{minWidth:'720px!important'}}>
      <DialogTitle sx={{color: 'blue'}}>{props.dialogTitle}</DialogTitle>
      <Stack sx= {{ m: 1}}>
        
      <MaterialReactTable table={props.dialogTitle === 'Part Location' ? table : tableHirarchy} />
        </Stack>
      {/* <List sx={{ pt: 0 }}>
        {selectedValue.map((chiled) => (
          <ListItem disablePadding key={chiled}>
            <ListItemButton >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  {props.dialogTitle === 'Part Hierarchy' ? <ExtensionIcon /> : <PlaceIcon/>}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={chiled} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton
            autoFocus
            onClick={() => handleClose()}
          >
            <ListItemAvatar>
              <Avatar>
                <CloseIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Exit" />
          </ListItemButton>
        </ListItem>
      </List> */}
      <DialogActions>
        <Button onClick={handleClose}>close</Button>
      </DialogActions>
    </Dialog>
  );
}
